import * as gfunctions from '../../../js/generalFunctions';

CCL.conflictModal = {
  autoload: [
    ['conflictBtnClick', $('#conflictModal').length > 0]
  ],

  displayedData: {},
  sendData: [],
  soldOutData: [],
  baseClass: '',
  fbtAddedProducts: [],

  conflictBtnClick() {
    $('body').on('click', '.checkoutConflictBtn', (event) => {
      const pageType = $('#pagetype').data('pagetype');
      if (pageType === 'CATEGORY') {
        const productPosition = Number($(event.target).data('productposition')) + 1;
        const pageNumber = Number($(event.target).data('currentpage')) + 1;
        const categoryName = $(event.target).data('sascategorycode');
        localStorage.setItem('productposition', productPosition);
        localStorage.setItem('pageNumber', pageNumber);
        localStorage.setItem('sascategorycode', categoryName);
      }
      event.preventDefault();
      const targetElement = $(event.target).data('hasvariants');
      const quantity = $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input') && $(event.target).parents('.c-pdp-card, .modal-content').find('.quantity-input').val();
      const variantId = $(event.target).attr('data-variantids');
      let productCode = $(event.target).data('productcode');
      if (!productCode) {
        productCode = $(event.currentTarget).data('productcode');
      }
      const hasupsell = $(event.target).attr('data-hasupsell');
      if (hasupsell === 'true' && typeof hasupsell !== typeof undefined && hasupsell !== false) {
        CCL.upSellProductModal.loadUpsellModal(productCode);
        this.baseClass = $(event.currentTarget.classList).last();
        return;
      }
      const csrf = $(event.target).data('csrf') ? $(event.target).data('csrf') : $('#csrfSessionToken').data('csrf');
      const dataObj = {
        productCodePost: productCode,
        CSRFToken: csrf,
        qty: quantity || 1,
        variantIds: variantId
      };
      if (targetElement === undefined || targetElement === '' || targetElement === false) {
        this.loadModalData(dataObj);
      }
    });
    $('body').on('click', '#conflictModalClose', (event) => {
      setTimeout(() => {
        $(`.${this.baseClass[0]}`).addClass('ada-element-focus');
        $(`.${this.baseClass[0]}`).focus();
      }, 800);
    });
  },

  async loadModalData(dataObj) {
    gfunctions.showLoader();
    let ajaxUrl = '';
    let method = 'POST';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/_ui/responsive/ccl/assets/templates/conflict-modals/checkout-conflict-modal.json';
      method = 'GET';
    } else {
      ajaxUrl = '/shop/cart/add';
    }
    try {
      const pageType = $('#pagetype').data('pagetype');
      dataObj.pageType = pageType;
      if (pageType === 'CATEGORY') {
        dataObj.productPosition = localStorage.getItem('productposition');
        dataObj.pageNumber = localStorage.getItem('pageNumber');
        dataObj.categoryName = localStorage.getItem('sascategorycode');
      }
      const inputDataObj = {
        url: ajaxUrl,
        type: method,
        data: dataObj
      };
      const res = await gfunctions.doAjax(inputDataObj);
      if (Object.keys(res).length !== 0 && res.constructor === Object && res.isProductAdded === false) {
        this.displayedData = this.modifyConflictJSON(res);
        this.openConflictModal(this.displayedData);
        gfunctions.hideLoader();
      } else {
        gfunctions.hideLoader();
        if (res.addedToCart === true) {
          gfunctions.updateHeaderCartWidget(res);
          CCL.addToCart.successModal(res);
        }
        console.log('Data is empty');
      }
      const { excursionsCountForFacet } = res;
      gfunctions.updateFacetData(excursionsCountForFacet);
    } catch (err) {
      const cartAPIError = { customError: err };
      gfunctions.hideLoader();
      console.log(cartAPIError);
    }
  },

  modifyConflictJSON(jsonData) {
    const { timeSlotsCard } = jsonData;
    for (let i = 0; i < timeSlotsCard.length; i++) {
      const { ticketsAvailability, bookingInformation } = timeSlotsCard[i];
      for (let j = 0; j < bookingInformation.length; j++) {
        const { guestInformation } = bookingInformation[j];
        for (let k = 0; k < guestInformation.length; k++) {
          guestInformation[k].isSelected = false;
          guestInformation[k].isDisabled = false;
          guestInformation[k].isSoldOut = false;
          if (Number(ticketsAvailability) === 0) {
            guestInformation[k].isPermanentDisabled = true;
            guestInformation[k].isSoldOut = true;
          }
        }
      }
    }
    return jsonData;
  },

  /**
  * ajax request to load HTML template for conflict modal
  * @param {Object} data
  */
  async openConflictModal(data) {
    try {
      const options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
      data.productCard.date = new Date(data.productCard.date).toLocaleDateString('en-US', options);
      const inputDataObj = {
        url: '/_ui/responsive/ccl/assets/templates/conflict-modals/checkout-conflict-modal.html',
        type: 'GET'
      };
      const response = await gfunctions.doAjax(inputDataObj);
      const html = gfunctions.createDynamicHTML(response, data);
      $('#conflictModalHtml').empty().append(html);
      gfunctions.showModal('conflictModal');
      gfunctions.hideLoader();
      if ($('.modal:visible').length) {
        setTimeout(() => {
          $('body').addClass('modal-open');
        }, 500);
      }
      this.modalClickEvents(); // call all javascript event after above html load
    } catch (error) {
      gfunctions.hideLoader();
      gfunctions.displayError(error);
    }
  },

  onAddToCart() {
    const productCard = gfunctions.getSelectedGuests(this.sendData);
    this.addToCartAjax(productCard);
  },

  addToCartAjax(ajaxData) {
    const jsonObjects = { productCard: ajaxData };
    const pageType = $('#pagetype').data('pagetype');
    jsonObjects.pageType = pageType;
    if (pageType === 'CATEGORY') {
      jsonObjects.productPosition = localStorage.getItem('productposition');
      jsonObjects.pageNumber = localStorage.getItem('pageNumber');
      jsonObjects.categoryName = localStorage.getItem('sascategorycode');
    }
    if (this.fbtAddedProducts.length) {
      jsonObjects.fbtAddedProducts = this.fbtAddedProducts;
    }
    const token = $('#csrfSessionToken').data('csrf');
    gfunctions.showLoader();
    $.ajax({
      type: 'POST',
      contentType: 'application/json',
      url: '/shop/cart/addToCart',
      data: JSON.stringify(jsonObjects),
      dataType: 'json',
      beforeSend: (xhr) => {
        xhr.setRequestHeader('CSRFToken', token);
      },
      success: (res) => {
        gfunctions.hideLoader();
        if (res.addedToCart === true) {
          gfunctions.updateHeaderCartWidget(res);
          this.fbtAddedProducts = [];
          CCL.addToCart.successModal(res);

          if (jsonObjects.fbtAddedProducts && jsonObjects.fbtAddedProducts.length) {
            this.fbtAddedProducts = [];
            // if you are on cart page then reload the page for FBT
            if ($('body').find('.c-cart').length) {
              $('body').find('#addToCartSuccessModal .close').addClass('refresh-window');
              $('body').find('#addToCartSuccessModal .keepShopingLink').attr('href', '/booked/home');
            }
          }
        }
        this.sendData = [];
        console.log('Something went well');
        const { excursionsCountForFacet } = res;
        gfunctions.updateFacetData(excursionsCountForFacet);
        gfunctions.hideModal('conflictModal');
      },
      error: (error) => {
        gfunctions.hideLoader();
        gfunctions.hideModal('conflictModal');
        console.log('Something went wrong');
      }
    });
  },

  modalClickEvents() {
    // expand first available slot by default
    this.expandFirstAvailable();

    $('#AddToCartBtn').click((e) => {
      this.onAddToCart();
    });

    $('.conflict-panel-timing').click((e) => {
      $(e.currentTarget).find('img:not(.tick-mark)').toggleClass('time-conflict-img-rotate');
    });
    /* eslint-disable */
    $('.custom-checkbox').click((e) => {
      if (e.target.tagName === 'INPUT') {
        const cuurentID = e.currentTarget.id.split('-');
        const curVarientID = cuurentID[0];
        const curBookingID = cuurentID[1];
        const curGuestID = cuurentID[2];
        let currentBufferStartTime = '';
        let currentBufferEndTime = '';
        this.createSelectedGuests(curVarientID, curBookingID, curGuestID);
        const { isTransferProduct, timeSlotsCard } = this.displayedData;

        for (let i = 0; i < timeSlotsCard.length; i++) {
          if (timeSlotsCard[i].variantId === curVarientID) {
            const { actualStartTime, actualEndTime } = timeSlotsCard[i];
            currentBufferStartTime = actualStartTime.split(' ')[3].split(':');
            currentBufferEndTime = actualEndTime.split(' ')[3].split(':');
          }
        }

        for (let i = 0; i < timeSlotsCard.length; i++) {
          if (timeSlotsCard[i].variantId !== curVarientID) { // disable guests in remaining timeslots
            const { bookingInformation, actualStartTime, actualEndTime } = timeSlotsCard[i];
            const guestBufferStartTime = actualStartTime.split(' ')[3].split(':');
            const guestBufferEndTime = actualEndTime.split(' ')[3].split(':');
            for (let j = 0; j < bookingInformation.length; j++) {
              const { guestInformation } = bookingInformation[j];
              for (let k = 0; k < guestInformation.length; k++) {
                const { guestId, errorText } = guestInformation[k];
                if (guestId === curGuestID) {
                  if (isTransferProduct === 'true' || this.getTimeConflictStatus(guestBufferStartTime, guestBufferEndTime, currentBufferStartTime, currentBufferEndTime)) {
                    if ($(`#${curVarientID}${curBookingID}${curGuestID}`).is(':checked')) {
                      $(`#${timeSlotsCard[i].variantId}${bookingInformation[j].bookingId}${guestId}`)[0].disabled = true;
                      $(`#${timeSlotsCard[i].variantId}${bookingInformation[j].bookingId}${guestId}`)[0].checked = false;
                      $(`#${timeSlotsCard[i].variantId}-${bookingInformation[j].bookingId}-${guestId}`)[0].classList.add('div-disabled');
                      guestInformation[k].isDisabled = true;
                    } else {
                      if (!errorText) {
                        $(`#${timeSlotsCard[i].variantId}${bookingInformation[j].bookingId}${guestId}`)[0].disabled = false;
                        $(`#${timeSlotsCard[i].variantId}-${bookingInformation[j].bookingId}-${guestId}`)[0].classList.remove('div-disabled');
                        guestInformation[k].isDisabled = false;
                      }
                    }
                  } else {
                    console.log('not checked');
                    if (!errorText) {
                      if (guestInformation[k].isDisabled && !guestInformation[k].isSoldOut) {
                        const ticketsAvailElement = $(`#id${timeSlotsCard[i].variantId}`).find('.tickets-availability-text span');
                        if (ticketsAvailElement[0].textContent !== 'No more tickets available') { // added on special purpose
                          $(`#${timeSlotsCard[i].variantId}${bookingInformation[j].bookingId}${guestId}`)[0].disabled = false;
                          $(`#${timeSlotsCard[i].variantId}-${bookingInformation[j].bookingId}-${guestId}`)[0].classList.remove('div-disabled');
                          guestInformation[k].isDisabled = false;
                        }
                      }
                    }
                  }
                  break;
                }
              }
            }
          } else {
            timeSlotsCard[i] = this.updateUserselection(timeSlotsCard[i], curBookingID, curGuestID);
          }
        }
        $('#AddToCartBtn')[0].disabled = !this.sendData.length;
        this.getCurrentSelected(timeSlotsCard); // get count of selected user
        this.displaySoldOut_SpecificTimeSlot(timeSlotsCard, curVarientID, curBookingID, curGuestID);
      }
    });
    /* eslint-enable */
  },

  expandFirstAvailable() {
    $.each(this.displayedData.timeSlotsCard, (index, value) => {
      const notAllConflicating = value.bookingInformation.some(x => !x.allConflict);
      // if not notAllConflicating means one checkbox is available
      if (notAllConflicating) {
        // expand the section by triggering click event
        $(`#id${value.variantId} .expandCollapseImage`).trigger('click');
        $(`#id${value.variantId} .expandCollapseImage img`).addClass('time-conflict-img-rotate');
        return false;
      }
      return true;
    });
  },

  getTimeConflictStatus(guestBufferStartTime, guestBufferEndTime, currentBufferStartTime, currentBufferEndTime) {
    let timeSlotConflict = false;

    const curentStartTimeConflict = (new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us'));
    const currentEndTimeConflict = (new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us'));

    const guestStartTimeConflict = (new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, guestBufferStartTime[0], guestBufferStartTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us'));
    const guestEndTimeConflict = (new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us') >= new Date(0, 0, 0, currentBufferStartTime[0], currentBufferStartTime[1], 0).toLocaleString('en-us') && new Date(0, 0, 0, guestBufferEndTime[0], guestBufferEndTime[1], 0).toLocaleString('en-us') <= new Date(0, 0, 0, currentBufferEndTime[0], currentBufferEndTime[1], 0).toLocaleString('en-us'));

    if (curentStartTimeConflict || currentEndTimeConflict || guestStartTimeConflict || guestEndTimeConflict) {
      timeSlotConflict = true;
    }

    return timeSlotConflict;
  },

  updateUserselection(timeSlotsCard, curBookingID, curGuestID) {
    const { bookingInformation } = timeSlotsCard;
    for (let x = 0; x < bookingInformation.length; x++) {
      if (bookingInformation[x].bookingId === curBookingID) {
        const { guestInformation } = bookingInformation[x];
        for (let y = 0; y < guestInformation.length; y++) {
          if (guestInformation[y].guestId === curGuestID) {
            if (!guestInformation[y].isSelected) {
              guestInformation[y].isSelected = true;
            } else {
              guestInformation[y].isSelected = false;
            }
          }
        }
      }
    }
    return timeSlotsCard;
  },

  createSelectedGuests(curVarientID, curBookingID, curGuestID) {
    if ($(`#${curVarientID}${curBookingID}${curGuestID}`).is(':checked')) {
      if (!this.sendData.includes(`${curVarientID}-${curBookingID}-${curGuestID}`)) {
        this.sendData.push(`${curVarientID}-${curBookingID}-${curGuestID}`);
      }
    } else {
      this.sendData = this.sendData.filter(el => el !== `${curVarientID}-${curBookingID}-${curGuestID}`);
    }
  },

  getCurrentSelected(timeSlotsCard) {
    const test = gfunctions.getSelectedGuests(this.sendData);
    $('.current-selected').empty();
    $.each(test, (index, value) => {
      $(`#currentSelected-${value.variantId}`).empty();
      if (timeSlotsCard.filter((x) => x.variantId === value.variantId).length) {
        const appendText = value.guestList.length === 1 ? 'Guest selected' : 'Guests selected';
        $(`#currentSelected-${value.variantId}`).html(` ${value.guestList.length} ${appendText}`);
      }
    });
  },

  displaySoldOut_SpecificTimeSlot(timeSlotsCard, curVarientID, curBookingID, curGuestID) {
    const getCurrentTimeSlot = timeSlotsCard.filter((timeSlot) => timeSlot.variantId === curVarientID);
    // new code to fix bug this - #770540
    const ticketsAvailability = getCurrentTimeSlot.length ? getCurrentTimeSlot[0].ticketsAvailability : 0;

    // Old code below - commented bcz of #770540
    //  const { ticketsAvailability } = getCurrentTimeSlot[0];

    const selectedGuests = gfunctions.getSelectedGuests(this.sendData);
    let selectedGuestCount = null;
    $.each(selectedGuests, (index, value) => {
      if (value.variantId === curVarientID) {
        selectedGuestCount = value.guestList.length;
      }
    });

    if (ticketsAvailability === selectedGuestCount) {
      for (let i = 0; i < getCurrentTimeSlot.length; i++) {
        const { bookingInformation } = getCurrentTimeSlot[i];
        for (let j = 0; j < bookingInformation.length; j++) {
          const { guestInformation } = bookingInformation[j];
          for (let k = 0; k < guestInformation.length; k++) {
            // if (!guestInformation[k].isSelected && !guestInformation[k].errorText && !guestInformation[k].isDisabled) {
            if (!guestInformation[k].errorText) {
              if (!guestInformation[k].isSelected) {
                $(`#${getCurrentTimeSlot[i].variantId}${bookingInformation[j].bookingId}${guestInformation[k].guestId}`)[0].disabled = true;
                const currentDivId = `${getCurrentTimeSlot[i].variantId}-${bookingInformation[j].bookingId}-${guestInformation[k].guestId}`;
                $(`#${currentDivId}`)[0].classList.add('div-disabled');
                guestInformation[k].isDisabled = true;
                const soldOutLabel = $(`#${currentDivId}`).find('.redtext');
                soldOutLabel[0].innerText = 'Sold Out';
                guestInformation[k].isSoldOut = true;
                this.soldOutData.push(currentDivId);
              }
            }
          }
        }
      }
      const ticketsAvailElement = $(`#id${curVarientID}`).find('.tickets-availability-text span');
      ticketsAvailElement[0].textContent = 'No more tickets available';
      ticketsAvailElement[0].classList.add('no-more-tickets');
    } else {
      const ticketsAvailElement1 = $(`#id${curVarientID}`).find('.tickets-availability-text span');
      if (ticketsAvailElement1.length && ticketsAvailElement1[0].textContent === 'No more tickets available') { // Remove Sold Out
        const remainingSoldData = [];
        $.each(this.soldOutData, (currentIndex, soldOutID) => {
          const newVarientId = soldOutID.split('-')[0];
          const newBookingId = soldOutID.split('-')[1];
          const newGuestId = soldOutID.split('-')[2];
          if (curVarientID === newVarientId) {
            $(`#${newVarientId}${newBookingId}${newGuestId}`)[0].disabled = false;
            $(`#${soldOutID}`)[0].classList.remove('div-disabled');
            const soldOutLabel = $(`#${soldOutID}`).find('.redtext');
            soldOutLabel[0].textContent = '';
            for (let a = 0; a < getCurrentTimeSlot.length; a++) {
              const { bookingInformation } = getCurrentTimeSlot[a];
              for (let b = 0; b < bookingInformation.length; b++) {
                const { bookingId, guestInformation } = bookingInformation[b];
                // if (bookingId === newBookingId) {
                for (let c = 0; c < guestInformation.length; c++) {
                  if (guestInformation[c].guestId === newGuestId) {
                    guestInformation[c].isSelected = false;
                    guestInformation[c].isDisabled = false;
                    guestInformation[c].isSoldOut = false;
                    break;
                  }
                }
                // }
              }
            }
            // this.soldOutData.splice(currentIndex, 1);
          } else {
            remainingSoldData.push(soldOutID);
          }
        });
        this.soldOutData = remainingSoldData;
        console.log(remainingSoldData);
        const ticketText = Number(ticketsAvailability) > 1 ? 'Tickets' : 'Ticket';
        ticketsAvailElement1[0].textContent = `${ticketsAvailability} ${ticketText} Available`;
        ticketsAvailElement1[0].classList.remove('no-more-tickets');
      }
    }
  }

};



// WEBPACK FOOTER //
// ./src/app/components/c-checkout-conflict-modal/checkout-conflict-modal.js